import libs from '@/request/api/libs'
import image from '@/request/api/images'
import audio from '@/request/api/audios'
import user from '@/request/api/users'
import show from '@/request/api/shows'
import episode from '@/request/api/episodes'
import category from '@/request/api/categories'
import order from '@/request/api/orders'
import comment from '@/request/api/comments'
import hotcomment from '@/request/api/hotcomments'
import normal from '@/request/api/normal'
import like from '@/request/api/likes'
import productitem from '@/request/api/productitems'
import history from '@/request/api/history'
import giftcard from '@/request/api/giftcards'
import invitation from '@/request/api/invitations'
import notice from '@/request/api/notices'
import noticeConfig from '@/request/api/config/notice'
import topic from '@/request/api/topics'
import topicConfig from '@/request/api/config/topic'
import topSwipe from '@/request/api/topswipes'
import topSwipeConfig from '@/request/api/config/topswipe'
import latestEpisodesConfig from '@/request/api/config/latestepisodes'
import todayRecommend from '@/request/api/today-recommend'
import todayRecommendsConfig from '@/request/api/config/todayrecommends'
import voucher from '@/request/api/vouchers'
import voucherConfig from '@/request/api/config/voucher'
import topList from '@/request/api/toplists'

export default {
  libs,
  image,
  audio,
  user,
  show,
  episode,
  category,
  order,
  comment,
  hotcomment,
  normal,
  like,
  productitem,
  history,
  giftcard,
  invitation,
  notice,
  noticeConfig,
  topic,
  topicConfig,
  topSwipe,
  topSwipeConfig,
  latestEpisodesConfig,
  todayRecommend,
  todayRecommendsConfig,
  voucher,
  voucherConfig,
  topList
}
